import { OrgUserSearchResult } from '@cibo/core'
import { CreateUserForm } from '@cibo/profile'
import { Box, Typography } from '@mui/material'
import { LayoutSection } from 'components/ImpactLayout'
import { ADMIN_ROUTES } from 'navigation/types'
import { useSnackbar } from 'notistack'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

export const CreateUser = () => {
  const { t } = useTranslation('impact/pages/CreateUser')
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()

  const handleComplete = useCallback((user: OrgUserSearchResult) => {
    enqueueSnackbar(t('success'), { variant: 'success' })
    navigate(generatePath(ADMIN_ROUTES.USER_DETAIL, { userId: user.userId.toString() }), {
      replace: true,
    })
  }, [])

  const handleCancel = useCallback(() => navigate(ADMIN_ROUTES.USER_LIST), [navigate])

  return (
    <LayoutSection>
      <Typography variant="h5">{t('createUser')}</Typography>
      <Box sx={{ maxWidth: 960 }}>
        <CreateUserForm onCancel={handleCancel} onComplete={handleComplete} />
      </Box>
    </LayoutSection>
  )
}
